import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_iframedialog');

register('wm-iframedialog', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmIframeDialog #${counter}="wmIframeDialog" wm-navigable-element="true" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
